import { useEffect, useContext } from 'react';
import { LoyaltyAccountDataType } from '@packages/shared/src/hooks/useLoyaltyApi/useLoyaltyApi';
import { useSWRConfig } from 'swr';
import { PaybackFetchMethodContext } from './PaybackAccountDataFetchProvider';

// this is a temporary workaround to handle the case when the overlay is closed
// this component is used in order to observe the payback overlay container, which is created by the payback client
// why not just use their onSuccess callback? because they don't have one on layer-close, only on layer-open
export type PaybackObserverOverlayProps = {
  closeOverlay: () => void;
};
export const PaybackObserverOverlay = ({ closeOverlay }: PaybackObserverOverlayProps) => {
  const { setFetchMethod, fetchMethodRef } = useContext(PaybackFetchMethodContext);
  const { mutate } = useSWRConfig();
  useEffect(() => {
    const isDivInDOM = () =>
      document.getElementById('payback-online-integration-overlay-container') !== null;

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          // Check to see if the div was removed (thats all we care about)
          if (!isDivInDOM() && fetchMethodRef.current === LoyaltyAccountDataType.Current) {
            setFetchMethod(LoyaltyAccountDataType.AllUpdated);
            closeOverlay();
            mutate('getLoyaltyAccountData');
          }
        }
      }
    });
    // subtree false because we expect the div to be added directly to the body
    observer.observe(document.body, { childList: true, subtree: false });

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};
